import { Timeline, Typography } from 'antd';

interface TimelineEvent {
  label: string;
  description?: string;
  color?: string;
}

interface TimelineArtifactRendererProps {
  content: TimelineEvent[];
}

function TimelineArtifactRenderer({
  content,
}: TimelineArtifactRendererProps) {
  if (!Array.isArray(content)) return null;

  return (
    <Timeline>
      {content.map((event, index) => (
        <Timeline.Item key={index} color={event.color ?? 'blue'}>
          <Typography.Text strong>{event.label}</Typography.Text>
          {event.description && (
            <Typography.Paragraph
              type="secondary"
              style={{ marginBottom: 0, fontSize: 13 }}
            >
              {event.description}
            </Typography.Paragraph>
          )}
        </Timeline.Item>
      ))}
    </Timeline>
  );
}

export default TimelineArtifactRenderer;
